import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LayoutDashboard, Trello, Calendar, LogOut } from "lucide-react";
import Logo from "../components/Logo";

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const navItem = "label-caps px-6 py-4 border-l-2 transition-all flex items-center gap-3";
  const navActive = "border-[#F4F4F0] bg-white/5 text-white";
  const navIdle = "border-transparent text-white/50 hover:text-white hover:bg-white/[0.03]";

  return (
    <div className="min-h-screen flex">
      <aside className="w-60 border-r border-white/5 bg-[#050505] flex flex-col sticky top-0 h-screen">
        <div className="p-6 border-b border-white/5">
          <Logo size={40} />
          <div className="label-caps text-white/30 mt-3">Studio OS</div>
        </div>

        <nav className="flex-1 py-6">
          <NavLink to="/admin/dashboard" data-testid="nav-dashboard" className={({isActive}) => `${navItem} ${isActive ? navActive : navIdle}`}>
            <LayoutDashboard size={14} /> Dashboard
          </NavLink>
          <NavLink to="/admin/pipeline" data-testid="nav-pipeline" className={({isActive}) => `${navItem} ${isActive ? navActive : navIdle}`}>
            <Trello size={14} /> Pipeline
          </NavLink>
          <NavLink to="/admin/calendar" data-testid="nav-calendar" className={({isActive}) => `${navItem} ${isActive ? navActive : navIdle}`}>
            <Calendar size={14} /> Calendar
          </NavLink>
        </nav>

        <div className="p-6 border-t border-white/5">
          <div className="mb-3">
            <div className="text-sm font-medium" data-testid="user-name">{user?.name}</div>
            <div className="text-xs text-white/40">{user?.email}</div>
          </div>
          <button onClick={async () => { await logout(); nav("/"); }} data-testid="logout-btn"
            className="label-caps text-white/50 hover:text-white transition flex items-center gap-2">
            <LogOut size={12} /> Sign Out
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
